<template>
	<vue-tags-input
		v-model="tag"
		:placeholder="$t('Ajouter vos tags')"
		:tags="tags"
		:autocomplete-items="suggestions"
		:style="tagsStyle"
		:allow-edit-tags="true"
		:autocomplete-filter-duplicates="true"
		:avoid-adding-duplicates="true"
		:autocomplete-min-length="0"
		@tags-changed="newTags => (tags = newTags)"
	/>
</template>

<script>
	import { mapState } from "vuex";

	import VueTagsInput from "@johmun/vue-tags-input";

	export default {
		name: "MenuTags",
		components: {
			VueTagsInput
		},
		data() {
			return {
				tag: "",
				suggestions: []
			};
		},
		computed: {
			...mapState({
				appId: state => state.app.id,
				background: state => state.settings.accentColor.background,
				foreground: state => state.settings.accentColor.foreground
			}),
			tags: {
				get() {
					return this.$store.state.tags.tags;
				},
				set(tags) {
					this.$store.commit("tags", tags);
				}
			},
			tagsStyle() {
				return {
					"--color-background": this.background,
					"--color-foreground": this.foreground
				};
			}
		},
		async created() {
			if (this.appId === 0) {
				return;
			}

			const tags = await this.$store.dispatch("getTags", this.appId);

			this.suggestions = tags
				.filter(suggestion => {
					return suggestion.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
				})
				.map(suggestion => ({ text: suggestion }));
		}
	};
</script>

<style lang="scss">
	.ti-tag {
		background-color: var(--background) !important;
		color: var(--text) !important;
	}

	.ti-selected-item {
		background-color: var(--background) !important;
		color: var(--text) !important;
	}

	.ti-input {
		border-radius: 6px;
		border: 1px solid var(--border) !important;

		&:focus-within,
		&:focus {
			border-color: var(--text) !important;
		}
	}
</style>
